// Inside the thread runtime: publishes whether the chat is saving a store's design right now, for the storefront
// canvas's "Updating…" (storefront-canvas.tsx). Kept apart from the canvas so the canvas never loads the runtime.
import { useEffect, useMemo, type FC } from 'react';
import { useAuiState } from '@assistant-ui/react';
import { publishUpdating } from './storefront-canvas';

type Part = { type?: string; toolName?: string; result?: unknown };
type Message = { role?: string; parts?: readonly Part[]; content?: readonly Part[] };
/** Inside the thread runtime: whether the chat is saving a design right now. */
export const StorefrontDesignObserver: FC<{ threadId: string }> = ({ threadId }) => {
  const running = useAuiState((s) => s.thread.isRunning);
  const messages = useAuiState((s) => s.thread.messages) as unknown as readonly Message[];
  const busy = useMemo(() => {
    const last = messages.at(-1);
    const parts = last?.role === 'assistant' ? (last.parts ?? last.content ?? []) : [];
    return (
      running &&
      parts.some(
        (part) =>
          part.type === 'tool-call' &&
          part.toolName === 'change_storefront_design' &&
          part.result === undefined,
      )
    );
  }, [messages, running]);
  useEffect(() => publishUpdating(threadId, busy), [threadId, busy]);
  return null;
};
